import './App.css';
import Vistagram from './component/vistagram/vistagram';

function App() {
  return (
    <Vistagram />
  );
}

export default App;
